import React from 'react';
import { Typography } from '@mui/material';
import { useLanguage } from 'context/AppContext';
import * as Styles from './EmptyState.styles';

const EmptyState: React.FC = ({ ...rest }) => {
  const [language] = useLanguage();
  return (
    <Styles.Container>
      <Styles.FolderOffOutlinedStyled fontSize="large" />
      <Typography variant="subtitle2">{language.EmptyState.noResults}</Typography>
    </Styles.Container>
  );
};

export default EmptyState;
